import React, { useState, useEffect } from "react";
import Loading from "../Loader/Loading";
import "./shift.css";
import { useNavigate } from "react-router-dom";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoMdArrowRoundBack } from "react-icons/io";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";

const Shift = () => {
  const [shiftdetails, setshiftdetails] = useState([]);
  const [shifttimings, setshifttimings] = useState([]);
  const [filteredshifttimings, setfilteredshifttimings] = useState([]);
  const [modifyshift, setmodifyshift] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [CustomShift, setCustomShift] = useState(false);
  const [newuser, setnewuser] = useState({
    shiftname: "",
    shiftStartTime: "",
    shiftendTime: "",
  });

  const Navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(shiftdetails.length / itemsPerPage);

  const paginatedData = shiftdetails.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePageClick = (pageNum) => {
    setCurrentPage(pageNum);
  };

  const handlehomepage = () => {
    Navigate("/CM");
  };

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const handlemodifyshift = async () => {
    if (
      !modifyshift ||
      Object.keys(modifyshift).length === 0 ||
      Object.values(modifyshift).some((shift) => {
        if (!shift.type || !shift.date) return true;

        const selectedDate = new Date(shift.date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return selectedDate < today;
      })
    ) {
      toast.error("Please select a valid future date and type for all users");
      return;
    }

    setIsLoading(true);

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/modifyshift.php`;
    const entries = Object.entries(modifyshift);

    for (const [userId, shift] of entries) {
      if (!shift.type || !shift.date) continue;

      const user = shiftdetails.find((u) => u.id.toString() === userId);
      const formData = new FormData();
      formData.append("user_id", user?.user_id);
      formData.append("assignedby_id", userDetails?.id);
      formData.append("new_shift", shift.type);
      formData.append("start_date", shift.date);

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();

        if (data.message) {
          toast.success(`User ${user?.user_name || userId}'s ${data.message}`);
          getshiftdetails();
        } else {
          toast.error(`User ${user?.user_name || userId}: Update failed`);
        }
      } catch (error) {
        toast.error(`User ${user?.user_name || userId}: Request error`);
      } finally {
        setIsLoading(false);
      }
    }
    setmodifyshift({});
  };

  const getshiftdetails = async () => {
    try {
      const formData = new FormData();
      formData.append("sub", userDetails?.sub);
      formData.append("client_id", userDetails?.clientid);

      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getshiftdetails.php`;
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result.message === "Records fetched successfully") {
        setshiftdetails(result.data);
      } else {
        console.log("Unexpected response:", result);
      }
    } catch (error) {
      console.log("Error fetching shift details:", error);
    }
  };

  const handlecustomshift = async (e) => {
    e.preventDefault();

    const { shiftname, shiftStartTime, shiftendTime } = newuser;

    if (!shiftname || !shiftStartTime || !shiftendTime) {
      alert("Please enter all shift details");
      return;
    }

    // Convert 12-hour time string to minutes for validation
    const parseTime = (timeStr) => {
      const [time, period] = timeStr.split(" ");
      let [hours, minutes] = time.split(":").map(Number);
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      return hours * 60 + minutes;
    };

    // Convert minutes back to 12-hour format
    const formatTime = (minutes) => {
      let hrs = Math.floor(minutes / 60);
      let mins = minutes % 60;
      const period = hrs >= 12 ? "PM" : "AM";
      if (hrs === 0) hrs = 12;
      if (hrs > 12) hrs -= 12;
      const minsStr = mins < 10 ? `0${mins}` : mins;
      return `${hrs}:${minsStr} ${period}`;
    };

    const startMinutes = parseTime(shiftStartTime);
    const endMinutes = parseTime(shiftendTime);

    if (endMinutes <= startMinutes) {
      alert("End time must be greater than start time");
      return;
    }

    const formData = new FormData();
    formData.append("shift_name", shiftname);
    formData.append(
      "shift_time",
      `${formatTime(startMinutes)} - ${formatTime(endMinutes)}`
    );
    formData.append("client_id", newuser?.clientname || userDetails?.clientid);
    formData.append("sub", userDetails?.sub);

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createshift.php`;

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Shift created successfully!");
        setCustomShift(false);
        setnewuser({
          shiftname: "",
          shiftStartTime: "",
          shiftendTime: "",
        });
      } else {
        toast.error("Error: " + (data.message || "Something went wrong"));
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong while creating the shift");
    }
  };

  useEffect(() => {
    getshiftdetails();
  }, []);

  useEffect(() => {
    if (userDetails?.role === "admin") {
      const adminShifts = shifttimings.filter(
        (shift) =>
          String(shift.client_id) ===
          String(newuser?.clientname || userDetails?.clientid)
      );
      setfilteredshifttimings(adminShifts);
    } else {
      const clientShifts = shifttimings.filter(
        (shift) => shift.client_id === userDetails?.clientid
      );
      setfilteredshifttimings(clientShifts);
    }
  }, [newuser?.clientname, userDetails?.role, shifttimings]);

  return (
    <>
      <div className="align">
        <button className="button" onClick={handlehomepage}>
          <svg>
            <FaLongArrowAltLeft />
          </svg>
          <div className="text">Home</div>
        </button>
      </div>
      <div className="table-contain">
        <h2 className="shi">Shift Details</h2>
        {Array.isArray(shiftdetails) > 0 ? (
          <div className="table-scroll">
            <table className="shift-table">
              <thead>
                <tr>
                  <th>SI No</th>
                  <th>User Name</th>
                  <th>Contact No</th>
                  <th>Current Shift</th>
                  <th>Upcoming Shift</th>
                  <th>Assigned BY </th>
                  <th>Modify Shift</th>
                  <th>Start Date</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item, index) => (
                  <tr key={item.user_id}>
                    <td>{index + 1}</td>
                    <td>{item.user_name}</td>
                    <td>{item.phone_no}</td>
                    <td>{item.current_shift}</td>
                    <td>
                      {" "}
                      {item.start_date === "0000-00-00"
                        ? " "
                        : `${item.new_shift} - ${item.start_date}`}
                    </td>
                    <td>{item.ass_name}</td>
                    <td>
                      <select
                        value={modifyshift[item.id]?.type || ""}
                        onChange={(e) => {
                          setmodifyshift((pv) => ({
                            ...pv,
                            [item.id]: {
                              ...(pv[item.id] || {}),
                              type: e.target.value,
                            },
                          }));
                          if (e.target.value === "custom shift") {
                            setCustomShift(true);
                          } else {
                            setCustomShift(false);
                          }
                        }}
                      >
                        <option value="" disabled>
                          Select Shift
                        </option>
                        {filteredshifttimings.map((shift) => (
                          <option key={shift.id} value={shift.shift_name}>
                            {shift.shift_name} {shift.shift_time}
                          </option>
                        ))}
                        <option value={"custom shift"}>Create Shift</option>
                      </select>
                    </td>
                    <td>
                      <input
                        className="stda"
                        type="date"
                        value={modifyshift[item.id]?.date || ""}
                        onChange={(e) =>
                          setmodifyshift((pv) => ({
                            ...pv,
                            [item.id]: {
                              ...(pv[item.id] || {}),
                              date: e.target.value,
                            },
                          }))
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {CustomShift && (
              <div className="admin-portal-popup-overlay">
                <div className="admin-portal-popup-content">
                  <div className="admin-portal-header">
                    <button
                      className="admin-portal-back-btn"
                      onClick={() => {
                        setCustomShift(false);
                        setnewuser((pv) => ({ ...pv, shifttype: "" }));
                      }}
                    >
                      <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                    </button>
                    <h2 className="admin-portal-form-title">Custom Shift</h2>
                  </div>

                  <div className="admin-portal-form-section">
                    <form
                      onSubmit={handlecustomshift}
                      className="admin-portal-form"
                    >
                      <span className="admin-portal-label">Shift Name: </span>
                      <input
                        type="text"
                        className="admin-portal-input"
                        required
                        value={newuser?.shiftname}
                        onChange={(e) =>
                          setnewuser((pv) => ({
                            ...pv,
                            shiftname: e.target.value,
                          }))
                        }
                      />
                      {/* start time */}
                      <span className="admin-portal-label">Start Time: </span>
                      <TimePicker
                        required
                        className="admin-portal-input"
                        value={newuser.shiftStartTime}
                        onChange={(value) =>
                          setnewuser((pv) => ({ ...pv, shiftStartTime: value }))
                        }
                        format="hh:mm a"
                      />

                      {/* End Time */}
                      <span className="admin-portal-label">End Time: </span>
                      <TimePicker
                        required
                        className="admin-portal-input"
                        value={newuser.shiftendTime}
                        onChange={(value) =>
                          setnewuser((pv) => ({ ...pv, shiftendTime: value }))
                        }
                        format="hh:mm a"
                      />
                      <button type="submit" className="admin-portal-btn-create">
                        Create
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          "No Teams Have Been Created Yet"
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination-controls">
          <button onClick={handlePrev} disabled={currentPage === 1}>
            Prev
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={currentPage === i + 1 ? "active-page" : ""}
              onClick={() => handlePageClick(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button onClick={handleNext} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
      )}
      {Array.isArray(shiftdetails) && shiftdetails.length > 0 && (
        <div className="sbt">
          <button className="shbn" onClick={handlemodifyshift}>
            Submit
          </button>
        </div>
      )}

      {isLoading && <Loading type="shift" />}
    </>
  );
};

export default Shift;
